import { normalizeVitePublicUrlBase } from 'utils/vitePublicUrlBase';

/** Script URL for `public/sw.js`, respecting a non-root Vite base. */
export function abrafiServiceWorkerScriptUrl(
  baseUrl: string | undefined,
): string {
  return `${normalizeVitePublicUrlBase(baseUrl)}sw.js`;
}

/**
 * Registers the install service worker. Failure leaves the Install app
 * button hidden in browsers that still require a worker.
 */
export function registerAbrafiServiceWorker(
  baseUrl: string | undefined = import.meta.env.BASE_URL,
): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  const scriptUrl = abrafiServiceWorkerScriptUrl(baseUrl);
  const register = () => {
    void navigator.serviceWorker.register(scriptUrl).catch(() => {
      // Install stays unavailable when the worker cannot register.
    });
  };
  if (document.readyState === 'complete') {
    register();
    return;
  }
  window.addEventListener('load', register, { once: true });
}
